import React from 'react';
import Layout from '../../containers/Layout';
import ScrollToTop from '../../components/ScrollToTop';
import AppStoreProvider from '../../context/appStoreContext';
import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import { SessionListeners } from '../../components/SessionAuthWrapper';
import URL from '../../utils/helper';
import AppTourProvider from '../../context/appTourContext.js';
import { initIndexedDB } from '../../utils/indexedDBUtil.js';
import { EmbeddingProvider } from '../../context/embedContext.js';
import { AppRouter } from '../Router/index.js';

SuperTokens.init({
  appInfo: {
    apiDomain: URL.AUTH_BASE_URL,
    apiBasePath: URL.AUTH_BASE_PATH,
    appName: "PDS"
  },
  recipeList: [
    Session.init({
      autoAddCredentials: true,
      onHandleEvent: (event) => {
        console.log("session recipe onHandleEvent called !!");
        SessionListeners.notifyListeners(event);
      },
    }),

    EmailPassword.init({
      preAPIHook: async (context) => {
        let url = context.url;
        let requestInit = context.requestInit;
        return {
          requestInit, url
        };
      }
    }
    ),
    EmailVerification.init({
      mode: "REQUIRED"
    })
  ],
});

// Initialize IndexedDB to store document data
initIndexedDB();

const App = () => {
  return (
    <EmbeddingProvider>
      <AppRouter>
        <ScrollToTop>
          <AppStoreProvider>
            <AppTourProvider>
              <Layout />
            </AppTourProvider>
          </AppStoreProvider>
        </ScrollToTop>
      </AppRouter>
    </EmbeddingProvider>
  );
};

export default App;
